import './pagination.scss';
export class PaginationController {
    constructor() {
        this.getPaginationLabel = () => {
            return {
                start: ((this.page - 1) * this.itemsPerPage + 1),
                end: (this.page * this.itemsPerPage < this.totalNumberItems ? this.page * this.itemsPerPage : this.totalNumberItems),
                total: this.totalNumberItems,
            };
        };
        this.onChangePage = (event) => {
            const page = event.detail;
            if (this.page === page) {
                return;
            }
            this.page = page;
            this.onChange({ $page: this.page });
        };
        this.onChangeItem = (event) => {
            const { detail: { value } } = event;
            this.itemsPerPage = value;
            this.onChangeItemPerPage({ $itemsPerPage: this.itemsPerPage });
        };
    }
}
